import {AppAccessMobileApp} from "@ots-frontend/ots-data";
import {appAccessApps, AppAccessAppOption} from "./app-access-ui";

export type AppAccessAppSelectorProps = {
  value: AppAccessMobileApp[];
  onChange: (value: AppAccessMobileApp[]) => void;
  apps?: AppAccessAppOption[];
  disabled?: boolean;
  legend?: string;
};

/** Multi-select for choosing which OTS apps receive setup targets. */
export const AppAccessAppSelector = ({
  value,
  onChange,
  apps = appAccessApps,
  disabled = false,
  legend = "Apps",
}: AppAccessAppSelectorProps) => {
  const toggle = (app: AppAccessMobileApp) => onChange(
    value.includes(app) ? value.filter((item) => item !== app) : [...value, app]
  );

  return (
    <fieldset disabled={disabled}>
      <legend className="text-sm font-semibold">{legend}</legend>
      <div className="mt-2 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {apps.map((app) => (
          <label
            key={app.id}
            className="flex min-h-20 cursor-pointer items-center gap-3 rounded-xl border border-[var(--ots-outline-variant)] bg-[var(--ots-field)] px-3 py-3 text-sm transition-colors hover:border-[var(--ots-outline)] has-[:checked]:border-[var(--ots-primary)] has-[:checked]:bg-[var(--ots-primary-container)] has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-60">
            <input
              className="sr-only"
              type="checkbox"
              checked={value.includes(app.id)}
              onChange={() => toggle(app.id)}/>
            <img src={app.logo} alt="" className="size-11 shrink-0 rounded-xl"/>
            <span>
              <span className="block font-semibold text-[var(--ots-text)]">{app.label}</span>
              <span className="mt-0.5 block text-xs font-normal text-[var(--ots-text-muted)]">{app.description}</span>
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
};
